import useIntakeData from '../../services/intakeDataService';
import { useMemo } from 'react';
import {
  ITypeOfCarOption,
  therapyTypeEnum,
  SELECT_NONE_THERAPY_TYPE_OPTION,
} from './types';
import { isEmpty } from 'lodash';

export default function useTypeOfCarOptions(
  hasNullOption = true
): ITypeOfCarOption[] {
  const { data } = useIntakeData();
  const tocOptions = useMemo(
    () => [
      ...(hasNullOption && !isEmpty(data?.tocOptions)
        ? [SELECT_NONE_THERAPY_TYPE_OPTION]
        : []),
      ...((data?.tocOptions ?? [])
        .map(({ uuid, displayName, therapyType }) => ({
          value: uuid,
          label: `${displayName} [${
            therapyType && therapyTypeEnum[therapyType]
          }]`,
          displayName,
          therapyType,
        }))
        ?.sort((a, b) =>
          a.label.toLowerCase().localeCompare(b.label.toLowerCase())
        ) ?? []),
    ],
    [data?.tocOptions]
  );

  return tocOptions ?? [];
}
